import { dialog } from 'app/utils';
import { APIClient } from 'app/utils/client';
import i18n from 'app/i18n';
import { IModel, IResponse } from 'app/models';

export abstract class APIService {
  public constructor(
    private client: APIClient,
    private path: string,
  ) { }

  protected async intercept<T>(action: (client: APIClient, path: string) => Promise<IResponse<T>>): Promise<IResponse<T>> {
    return action(this.client, this.path).then((response) => {
      const { success, errors } = response;
      if (!success) errors?.forEach(({ code, message }) => {
        dialog.toast({ severity: 'error', title: i18n.t(`app.errors.${code}`), message });
      });

      return response;
    });
  }
}

export abstract class CRUDService<T extends IModel> extends APIService {
  public async query(params: any) {
    return this.intercept((c, p) => c.get<IResponse<T[]>>(p, { params }));
  }

  public async get(id: any) {
    return this.intercept((c, p) => c.get<IResponse<T>>(`${p}/${id}`));
  }

  public async save(data: T) {
    return this.intercept((c, p) => (!!data.id ? c.put<IResponse<T>>(`${p}/${data.id}`, data) : c.post<IResponse<T>>(p, data)));
  }

  public async delete({ id }: T) {
    return this.intercept((c, p) => c.delete<IResponse<T>>(`${p}/${id}`));
  }
}
